import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface AuthContextType {
  isAuthenticated: boolean;
  login: (email: string, password: string) => boolean;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

const VALID_EMAILS = [
  "testing@elio.so",
  "daniel.a.mueller@merckgroup.com",
  "tobias.biberger@boehringer-ingelheim.com",
  "michael-1.luescher@novartis.com",
  "kami@elio.earth",
  "alexander.haydl@boehringer-ingelheim.com",
];
const VALID_PASSWORD = "Jx@p8!Wd#Fk5";

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => sessionStorage.getItem("auth") === "1"
  );

  const login = useCallback((email: string, password: string) => {
    if (VALID_EMAILS.includes(email.toLowerCase()) && password === VALID_PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem("auth", "1");
      return true;
    }
    return false;
  }, []);

  const logout = useCallback(() => {
    setIsAuthenticated(false);
    sessionStorage.removeItem("auth");
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
